import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cva } from 'class-variance-authority';
import { useEffect, useRef } from 'react';
import { cn } from './utils/shadcn-utils';
const textboxVariants = cva('file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm focus-within:border-ring focus-within:ring-ring focus-within:ring-[var(--focus-ring-width)] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive', {
    variants: {
        variant: {
            default: 'bg-input border border-input-border',
            muted: 'bg-muted border-0 focus-within:ring-ring'
        },
        textboxSize: {
            default: 'h-9 px-3 py-2',
            sm: 'h-7 px-1.5 py-0.8',
            lg: 'h-10 px-4 py-2.5'
        }
    },
    defaultVariants: {
        variant: 'default',
        textboxSize: 'default'
    }
});
export const TextNumber = ({ placeholder, className, onChange, autoFocus, value, leftSide, rightSide, onEnter, variant, textboxSize, ...inputProps }) => {
    const inputRef = useRef(null);
    const handleChange = (e) => {
        const value = e.target.value;
        const numericValue = isNaN(parseFloat(value)) ? null : Number(value);
        if (onChange != null) {
            onChange(numericValue);
        }
    };
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (autoFocus) {
                inputRef.current?.focus();
            }
        }, 0);
        return () => {
            clearTimeout(timeoutId);
        };
    }, [autoFocus]);
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            if (onEnter != null) {
                onEnter(e);
            }
        }
    };
    return (_jsxs("div", { className: cn(textboxVariants({ variant, textboxSize }), className), children: [leftSide, _jsx("input", { type: "number", placeholder: placeholder, className: "w-full h-full outline-0 bg-transparent text-foreground placeholder:text-muted-foreground", onChange: handleChange, value: value ?? '', autoComplete: "off", onKeyDown: handleKeyDown, ...inputProps, ref: inputRef }), rightSide] }));
};
//# sourceMappingURL=TextNumber.js.map